import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n";

export const MarqueeRibbon = () => {
  const { t } = useLang();
  const items = t("marquee");

  return (
    <div data-testid="editorial-marquee" className="border-y border-amber-500/10 bg-[#0D0D10] py-6 overflow-hidden">
      <Marquee speed={32} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-2xl sm:text-3xl text-zinc-500 px-8 whitespace-nowrap">
              {item}
            </span>
            <span className="w-2 h-2 rotate-45 bg-[#D4AF37]/60 shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
